namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_benchmarks_catalog, {
		
		Menu: {
			flex: {
				basis: '20rem',
			},
		},
		
		Page: {
			Body_content: {
				flex: {
					direction: 'column',
				},
				gap: '1rem',
				padding: '1rem',
				width: '100%',
			},
		},
		
		Text: {
			flex: {
				shrink: 1,
			},
		},
		
		Chart_box: {
			position: 'relative',
			height: '31.2rem',
			width: '100%',
		},
		
	} )
	
}
